export const MEDICAL_GUIDE_PATH = "/medical-help-benalmadena";

export function isMedicalGuide(pathname) {
  return String(pathname || "").split(/[?#]/, 1)[0].replace(/\/+$/, "").toLowerCase() === MEDICAL_GUIDE_PATH;
}

export function isBlockedAnalyticsPath(pathname) {
  const path = String(pathname || "").split(/[?#]/, 1)[0].toLowerCase();
  return path.startsWith("/admin") || path.startsWith("/owner") ||
    path === "/me" || path.startsWith("/me/") ||
    path === "/venue-report" || path.startsWith("/venue-report/");
}
